module.exports = __webpack_public_path__ + "static/media/icon_5.dd000d24.png";